import { Routes } from '@angular/router'
import {
   PublicOnlyGuardService
} from '@appShared/services';
import {
    AuthResponseComponent,
   ErrorComponent,
    LandingComponent,
   ForgotPasswordComponent,
   LoginFailedComponent,
   PageNotFoundComponent,
   UnauthorizedComponent,
   SupportComponent,
   CaptureComponent,
   EOrderAppComponent,
   InternalShellComponent
} from '@appContainers/index'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { INTERNAL_ROUTES } from './shared/internal.routes'

export const APP_ROUTES: Routes = [
   {
      path: '',
      component: InternalShellComponent,
      children: [
         {
            path: '',
            canActivate: [PublicOnlyGuardService],
            component: LandingComponent
            //component: DashboardComponent
         },
         ...INTERNAL_ROUTES, /* If NOT lazy-loading */
         //...CONTENT_ROUTES, /* If NOT lazy-loading */
         //{
         //   path: SITE_DIRECTORY_ROUTES.internal.dashboard.baseUri,
         //   component: DashboardComponent,
         //   canActivate: [CanActivateGuardService, MsalGuard, AuthGuardService], /* remove if lazy-loading */
         //},
         {
            path: SITE_DIRECTORY_ROUTES.a4d_app.baseUri,
            component: EOrderAppComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.capture_app.baseUri,
            component: CaptureComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.forgot_password.baseUri,
            canActivate: [PublicOnlyGuardService],
            component: ForgotPasswordComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.support.baseUri,
            component: SupportComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.error.baseUri,
            component: ErrorComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.loginFailed.baseUri,
            component: LoginFailedComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.unauthorized.baseUri,
            component: UnauthorizedComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.auth.baseUri,
            component: AuthResponseComponent
         },
         {
            path: SITE_DIRECTORY_ROUTES.page_not_found.baseUri,
            component: PageNotFoundComponent
         },
         { path: '**', redirectTo: SITE_DIRECTORY_ROUTES.page_not_found.baseUri, pathMatch: 'full' }
      ]
   }
]
